import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} fill={fillColor} viewBox='0 0 128 128' className={className}>
      <g>
        <rect fill='none' height='402' width='582' y='-1' x='-1' />
      </g>
      <g>
        <path d='m64.005,114.135l-0.004,0c-27.641,0 -50.129,-22.487 -50.131,-50.128c0,-27.642 22.487,-50.129 50.129,-50.129s50.129,22.488 50.129,50.129c0,27.64 -22.485,50.128 -50.123,50.128zm-0.006,-96.258c-25.436,0 -46.129,20.693 -46.129,46.129c0.002,25.436 20.696,46.129 46.131,46.129l0.004,0c25.433,0 46.123,-20.693 46.123,-46.129s-20.693,-46.129 -46.129,-46.129z' />
        <path d='m64.478,92.582c-8.949,0 -16.23,-6.85 -16.23,-15.268c0,-1.104 0.896,-2 2,-2s2,0.896 2,2c0,6.213 5.486,11.268 12.23,11.268c6.743,0 12.229,-5.055 12.229,-11.268s-5.485,-11.268 -12.229,-11.268c-8.949,0 -16.23,-6.849 -16.23,-15.268c0,-8.418 7.281,-15.267 16.23,-15.267c4.811,0 9.342,1.988 12.434,5.455c0.735,0.825 0.663,2.089 -0.161,2.824s-2.09,0.662 -2.823,-0.161c-2.334,-2.617 -5.778,-4.118 -9.449,-4.118c-6.744,0 -12.23,5.054 -12.23,11.267c0,6.213 5.486,11.268 12.23,11.268c8.948,0 16.229,6.85 16.229,15.268s-7.282,15.268 -16.23,15.268z' />
        <path d='m64.032,99.842c-1.104,0 -2,-0.896 -2,-2l0,-67.59c0,-1.104 0.896,-2 2,-2s2,0.896 2,2l0,67.59c0,1.104 -0.895,2 -2,2z' />
        <line
          stroke={fillColor}
          transform='rotate(53 63.44445419311523,14.835468292236332) '
          y2='19.350784'
          x2='69.641654'
          y1='10.320153'
          x1='57.247252'
          strokeWidth='3.5'
          fill='none'
        />
        <line
          stroke={fillColor}
          transform='rotate(53 64.05204772949217,113.87342834472656) '
          y2='118.388741'
          x2='70.249249'
          y1='109.358109'
          x1='57.854847'
          strokeWidth='3.5'
          fill='none'
        />
        <line
          stroke={fillColor}
          transform='rotate(-36 12.609020233154322,61.82280349731446) '
          y2='66.338119'
          x2='18.806221'
          y1='57.307487'
          x1='6.41182'
          strokeWidth='3.5'
          fill='none'
        />
        <line
          stroke={fillColor}
          transform='rotate(-37 115.09001159667967,61.62026977539063) '
          y2='66.135587'
          x2='121.287217'
          y1='57.104956'
          x1='108.892815'
          strokeWidth='3.5'
          fill='none'
        />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
